import { IIconProps } from '~/types';
const AddItemIcon = (props: IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 8.625h4.5M9 6.375v4.5m6 4.875v-12a1.5 1.5 0 0 0-1.5-1.5h-9A1.5 1.5 0 0 0 3 3.75v12l3-1.5 3 1.5 3-1.5z"
      stroke="#2C3556"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AddItemIcon;
